import { render, staticRenderFns } from "./QuickExchange.vue?vue&type=template&id=9439cf76&scoped=true&"
import script from "./QuickExchange.vue?vue&type=script&lang=js&"
export * from "./QuickExchange.vue?vue&type=script&lang=js&"
import style0 from "./QuickExchange.vue?vue&type=style&index=0&id=9439cf76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9439cf76",
  null
  
)

export default component.exports